import React from "react";
import { Link, useLocation } from "react-router-dom";
import Banner from "../components/Banner";
import { INewsEventsData } from "../exports/interfaces";

const NewsDetailPage = () => {
  const location = useLocation();
  const state = location.state as { post?: INewsEventsData } | null;
  const post = state?.post;
  const imageUrls =
    post?.image?.map((item) => item.media.url) ??
    post?.thumbnail?.map((item) => item.media.url) ??
    [];

  return (
    <>
      <Banner title={post?.title ? "News" : "News Detail"} />

      <section id="news-detail">
        <div className="td_height_112 td_height_lg_40" />
        <div className="container">
          <div
            className="td_section_heading td_style_1 text-center wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <h2 className="td_section_title td_fs_48 mb-0">News Details</h2>
          </div>

          <div className="td_height_40 td_height_lg_30" />

          {post ? (
            <div className="td_post td_style_1">
              <div className="td_post_info">
                <div className="td_post_meta td_fs_14 td_medium td_mb_20">
                  <span>{post.date}</span>
                </div>
                <h2 className="td_post_title td_fs_36 td_medium td_mb_16">
                  {post.title}
                </h2>
                <p className="td_post_subtitle td_mb_24 td_heading_color td_opacity_7">
                  {post.sub_title}
                </p>

                {imageUrls.length > 0 && (
                  <div className="td_mb_30">
                    <div className="row g-3">
                      {imageUrls.map((url, index) => (
                        <div className="col-12" key={`news-image-${index}`}>
                          <img
                            src={process.env.REACT_APP_cmsUrl + url}
                            alt={`${post.title}${index + 1}`}
                            style={{ width: "100%", borderRadius: "20px" }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {post.text ? (
                  <div
                    className="td_post_content td_heading_color"
                    style={{ lineHeight: 1.9 }}
                    dangerouslySetInnerHTML={{ __html: post.text }}
                  />
                ) : (
                  <p className="td_post_subtitle td_heading_color td_opacity_7">
                    No additional content is available for this news item.
                  </p>
                )}

                <div className="td_height_50 td_height_lg_30" />

                <Link
                  to="/news"
                  className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                >
                  <span className="td_btn_in td_accent_color">
                    <span>Back to News</span>
                  </span>
                </Link>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="td_fs_18 td_heading_color td_opacity_7">
                News details are unavailable. Please return to the news list.
              </p>
              <div className="td_height_30 td_height_lg_30" />
              <Link
                to="/news"
                className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
              >
                <span className="td_btn_in td_accent_color">
                  <span>Return to News</span>
                </span>
              </Link>
            </div>
          )}
        </div>

        <div className="td_height_120 td_height_lg_40" />
      </section>
    </>
  );
};

export default NewsDetailPage;
